<template>
  <section>
    <b-modal :active.sync="showNewLeadDetail" v-if="showNewLeadDetail" :has-modal-card="true" :width="800" :can-cancel="false" :no-close-on-backdrop="true" :no-close-on-esc="true">
      <div class="modal-card">
        <header class="modal-card-head">
          <div class="columns">
            <div class="column is-12" style="padding-bottom:30px">
              <label class="label" v-if="!isCoAppSearch">Please fill in your contact details.</label>
              <label class="label" v-else>Please fill in your co-applicant details.</label>
            </div>
          </div>
        </header>
        <section class="modal-card-body">
          <form @submit.prevent="onValidate" :data-vv-scope="scope">
            <div class="columns is-multiline">
              <div class="column is-6">
                <div class="field">
                  <label class="label">Email<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                  <div class="control has-icons-right">
                    <input :name="validationName + 'email'" v-validate="{ 'required': true, 'email': true, 'max': 50 }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'email') }" :data-vv-scope="scope" data-vv-as="email" type="email" placeholder="Email" v-model="customer.email">
                    <span v-show="errors.has(validationName + 'email')" class="help is-danger">
                      <i v-show="errors.has(validationName + 'email')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'email') }}
                    </span>
                    <span class="icon is-small is-right">
                      <i class="fal fa-envelope default-blue"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="column is-6" v-show="!isCoAppSearch">
                <div class="field">
                  <label class="label">Social Security No.<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                  <div class="control">
                    <input
                      :name="validationName + 'ssn'"
                      data-vv-as="social security number"
                      v-validate="{ 'required': !isCoAppSearch, 'min': 11, 'max': 11 }"
                      :class="{ 'input': true, 'is-danger': errors.has(validationName + 'ssn') }"
                      :data-vv-scope="scope"
                      type="text"
                      v-model="customer.ssn"
                      placeholder="000-00-0000"
                      v-mask="'###-##-####'">
                    <span v-show="errors.has(validationName + 'ssn')" class="help is-danger">
                      <i v-show="errors.has(validationName + 'ssn')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'ssn') }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label">Date of Birth<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                  <div class="control has-icons-right">
                    <el-date-picker
                      :name="validationName + 'dateOfBirth'"
                      v-validate="{ 'required': true, 'minimum_age_18': true }"
                      :class="{ 'is-danger': errors.has(validationName + 'dateOfBirth') }"
                      :data-vv-scope="scope"
                      data-vv-as="date of birth"
                      size="default"
                      prefix-icon="none"
                      type="date"
                      format="MM/dd/yyyy"
                      placeholder="Click to select..."
                      v-model="customer.dateOfBirth"
                      :picker-options="datePickerOptions"
                      :default-value="defaultDate"
                      popper-class="datepicker-container"
                      :clearable="false"
                      style="width: 100%;">
                    </el-date-picker>
                    <span v-show="errors.has(validationName + 'dateOfBirth')" class="help is-danger">
                      <i v-show="errors.has(validationName + 'dateOfBirth')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'dateOfBirth') }}
                    </span>
                    <span class="icon is-small is-right">
                      <i class="fal fa-calendar-alt default-blue"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label">Mobile Phone</label>
                  <div class="control has-icons-right" style="padding-top: 8px;">
                    <input :name="validationName + 'mobile'" v-validate="{ 'required': false, 'min': 16, 'max': 16 }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'mobile') }" :data-vv-scope="scope" data-vv-as="mobile phone" type="tel" placeholder="+1(999)-999-9999" v-mask="'+1(###)-###-####'" v-model="customer.mobile">
                    <span v-show="errors.has(validationName + 'mobile')" class="help is-danger">
                      <i v-show="errors.has(validationName + 'mobile')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'mobile') }}
                    </span>
                    <span class="icon is-small is-right">
                      <i class="fal fa-mobile-android default-blue"></i>
                    </span>
                  </div>
                </div>
              </div>
              <!-- <div class="column is-6" v-if="!isCoAppSearch && !isCustomerCoApplicant">
                <div class="field">
                  <label class="label">Co-Applicant?<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                  <div class="control">
                    <multiselect
                      :multiple="false"
                      :name="validationName + 'relationshipStatus'"
                      v-validate="{ 'required': false }"
                      :class="{ 'is-danger': errors.has(validationName + 'relationshipStatus') }"
                      data-vv-scope="scope"
                      data-vv-as="co-applicant relationship status"
                      placeholder="Select Co-Applicant Relationship Status"
                      label="altName"
                      track-by="id"
                      :options="definedTypes.relationshipStatus.options"
                      :searchable="true"
                      v-model="selectedRelationshipStatus">
                    </multiselect>
                    <span v-show="errors.has(validationName + 'relationshipStatus')" class="help is-danger">
                      <i v-show="errors.has(validationName + 'relationshipStatus')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'relationshipStatus') }}
                    </span>
                  </div>
                </div>
              </div> -->
            </div>
          </form>
        </section>
        <footer class="modal-card-foot">
          <div class="columns" style="width: 100%;">
            <div class="column is-8 is-pulled-left">
              <button class="button is-primary is-pulled-left" :class="{ 'is-loading': this.isLoading }" type="button" @click.stop="onValidate">Proceed</button>
            </div>
            <div class="column is-4 is-pulled-right">
              <button class="button is-pulled-right is-info" type="button" @click.stop="navigateToBusiness">Switch to business app</button>
            </div>
          </div>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import moment from 'moment'
import customerService from '@/services/customerService'
import validateBeforeSubmitMixin from '@/mixins/generic/validateBeforeSubmit'

import { createNamespacedHelpers } from 'vuex'
const mapConfigGetters = createNamespacedHelpers('config').mapGetters

export default {
  inject: {
    $validator: '$validator'
  },
  name: 'CustomerLookup',
  props: {
    currentCustomer: null,
    subscriberId: {
      type: Number,
      default: 1
    },
    isCoAppSearch: {
      type: Boolean,
      default: false
    },
    scope: {
      type: String,
      default: 'customer-search'
    },
    useValidator: {
      type: Object,
      default: null
    },
    isLead: {
      type: Boolean,
      default: true
    },
    token: {
      type: String,
      default: ''
    }
  },
  mixins: [validateBeforeSubmitMixin],
  data () {
    return {
      instanceName: this.$uuid.v4(),
      availableCustomers: [],
      showNewLeadDetail: false,
      customer: this.currentCustomer,
      isLoading: false,
      defaultDate: new Date('01/01/1970'),
      datePickerOptions: {
        disabledDate (date) {
          return date.getFullYear() > new Date().getFullYear() - 18
        },
        defaultView: 'year'
      },
      selectedRelationshipStatus: null,
      coApplicant: null
    }
  },
  computed: {
    ...mapConfigGetters(['definedTypes']),
    validationName: function () {
      return (this.scope) ? this.scope + '.' + this.instanceName + '.' : this.instanceName + '.'
    },
    isCustomerCoApplicant: function () {
      return this.currentCustomer ? this.currentCustomer.isCoApplicant : false
    },
    hasCoApplicant: function () {
      return this.selectedRelationshipStatus && this.selectedRelationshipStatus.id !== 5 && !this.isCustomerCoApplicant
    }
  },
  methods: {
    onSave: function () {
      const leadSearchModel = {
        subscriberId: this.subscriberId,
        email: this.customer.email,
        mobile: this.customer.mobile,
        dateOfBirth: this.customer.dateOfBirth ? moment(this.customer.dateOfBirth).format('MM/DD/YYYY') : '',
        ssn: this.customer.ssn
      }

      if (!this.isCoAppSearch) {
        leadSearchModel.ssn = this.customer.ssn
      }

      this.isLoading = true
      customerService.findByContactInfo(leadSearchModel).then(response => {
        if (response.results !== null) {
          this.customer = response.results
          this.$emit('on-load-lead', this.customer)
        } else {
          this.$emit('on-no-lead', this.customer)
        }
        this.isLoading = false
      }).catch((error) => {
        this.$emit('on-no-lead', this.customer)
        this.isLoading = false
        this.serverErrorMessage = error.message
      })
    },
    onValidate: function () {
      this.validateBeforeSubmitScoped(this.scope)
    },
    getLineRowClass: function (row, index) {
      if (row.id === 0) {
        return 'lead-row-new'
      }
      return index % 2 === 0 ? 'row-striped' : ''
    },
    async navigateToBusiness () {
      if (this.isLead) {
        this.$router.push({ name: 'BusinessLeadCreditApplication', params: this.dealerCode })
      } else {
        this.$router.push({ name: 'BusinessCreditApplication', query: { token: this.token } })
      }
    },
    changeModalState: function (state) {
      this.showNewLeadDetail = state
    }
  },
  watch: {
    selectedRelationshipStatus: function (newValue) {
      if (newValue) {
        if (newValue.id !== 5) {
          this.$emit('on-co-app-type-change', this.selectedRelationshipStatus)
        }
      }
    }
  },
  mounted: function () {
    this.selectedRelationshipStatus = this.definedTypes.relationshipStatus.options.find((x) => x.id === 5)
    this.availableCustomers = []
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .label {
    text-align: left;
  }

  .icon .fa-mobile-android {
    padding-top: 15px;
  }

  .min-table-cells {
    padding-left:3px !important;
    padding-right:0 !important;
    font-size: 12px;
  }
</style>
